import { render, staticRenderFns } from "./scope-add.vue?vue&type=template&id=0c942a5a&"
import script from "./js/scope-add.js?vue&type=script&lang=js&"
export * from "./js/scope-add.js?vue&type=script&lang=js&"
import style0 from "./scope-add.vue?vue&type=style&index=0&id=0c942a5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports